import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import NotificationsIcon from "@mui/icons-material/Notifications";
import PersonIcon from "@mui/icons-material/Person";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import {
  Avatar,
  Button,
  Card,
  Grid,
  InputAdornment,
  InputBase,
  Popover,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
} from "@mui/material";

import { Link, useLocation, useNavigate } from "react-router-dom";
import UserContext from "../UseContext/UserContext";
import { Dashboard } from "@mui/icons-material";
import ListIcon from "@mui/icons-material/List";
import AutoModeIcon from "@mui/icons-material/AutoMode";

const drawerWidth = 220;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme }) => ({
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  variants: [
    {
      props: ({ open }) => open,
      style: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: `${drawerWidth}px`,
        transition: theme.transitions.create(["margin", "width"], {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.enteringScreen,
        }),
      },
    },
  ],
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

const notifications = [
  {
    title: "QTN–1024 has been generated successfully.",
    desc: "You can review it in the Quotation section.",
    time: "2 min ago",
  },
  {
    title: "Engineering review completed for Quotation #QTN–0978.",
    desc: "Awaiting your confirmation.",
    time: "2 min ago",
  },
  {
    title: "Ticket #TCK–3321 status updated.",
    desc: "Check progress in your tickets panel.",
    time: "2 min ago",
  },
];

const Main = styled("main", {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  flexGrow: 1,
  padding: theme.spacing(2),
  ///marginLeft: drawer == "miniopen" ? `${drawerWidth}` : "0px", // whichever your mini-drawer width
  transition: theme.transitions.create(["margin"], {
    duration: theme.transitions.duration.standard,
  }),
}));

export default function Navbar1({ children }) {
  const [hover, setHover] = React.useState(false);

  const [menuItems, setMenuItems] = React.useState([
    {
      text: "Machines",
      icon: ListIcon,
      activeicon: "",
      active: false,
      path: "MachineList",
      id: 0,
    },
    {
      text: "Dashboard",
      icon: Dashboard,
      activeicon: "",
      active: false,
      path: "Dashboard",
      id: 1,
    },
    {
      text: "Consumption",
      icon: AutoModeIcon,
      activeicon: "",
      active: false,
      path: "ConsuptionDashboard",
      id: 2,
    },
    {
      text: "Report",
      icon: InsertDriveFileIcon,
      activeicon: "",
      active: false,
      path: "Report",
      id: 3,
    },
  ]);
  const [heading, setHeading] = React.useState(
    sessionStorage.getItem("selectnav1") == null
      ? "Dashboard"
      : sessionStorage.getItem("selectnav1"),
  );

  const theme = useTheme();
  const [open, setOpen] = React.useState(true);

  const { drawer, setDrawer } = React.useContext(UserContext);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorEl2, setAnchorEl2] = React.useState(null);
  const [anchorEl3, setAnchorEl3] = React.useState(null);
  const location = useLocation();

  // alert(location.pathname);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick2 = (event) => {
    setAnchorEl2(event.currentTarget);
  };

  const handleClick3 = (event) => {
    setAnchorEl3(event.currentTarget);
  };

  const handleClose2 = () => {
    setAnchorEl2(null);
  };

  const handleClose3 = () => {
    setAnchorEl3(null);
  };

  const bellOpen = Boolean(anchorEl);
  const id = bellOpen ? "simple-popover" : undefined;

  const profileOpen = Boolean(anchorEl2);
  const id2 = profileOpen ? "simple-popover" : undefined;

  const chatbotOPen = Boolean(anchorEl3);
  const id3 = chatbotOPen ? "simple-popover" : undefined;

  // React.useEffect(() => {
  //   setDrawer("miniopen");
  // }, []);

  const navigate = useNavigate();

  const handleDrawerOpen = () => {
    setOpen(true);
    setDrawer("miniopen");
  };

  const handleDrawerClose = () => {
    setOpen(false);
    setDrawer("miniclose");
  };

  console.log(drawer);

  // React.useEffect(() => {
  //   if (sessionStorage.getItem("custaccuont") == null) {
  //     navigate("/");
  //   }
  // }, []);

  return (
    <Box sx={{ display: "flex", height: "100vh" }}>
      <CssBaseline />
      <AppBar
        position='fixed'
        // open={open}
        sx={{ backgroundColor: "#FAFAFA", boxShadow: "none" }}
      >
        <Toolbar>
          <IconButton
            color='inherit'
            aria-label='open drawer'
            onClick={handleDrawerOpen}
            edge='start'
            sx={[
              {
                mr: 2,
                color: "black",
              },
              open && { display: "none" },
            ]}
          >
            <MenuIcon />
          </IconButton>
          <Box
            display='flex'
            alignItems='center'
            justifyContent='space-between'
            width='100%'
            sx={{ backgroundColor: "#FAFAFA" }}
          >
            <Typography
              fontWeight={600}
              color='black'
              sx={{
                position: "absolute",
                fontFamily: "Poppins, sans-serif",
                fontSize: "1.5rem",
                top: 10,
                left: drawer == "miniopen" ? 245 : 85,
              }}
            >
              {sessionStorage.getItem("selectnav1")}
            </Typography>

            <Grid></Grid>

            <Box display='flex' alignItems='center' gap={1}>
              <Box
                sx={{
                  position: "relative",
                  display: "inline-flex",
                  cursor: "pointer",
                }}
                onClick={handleClick}
              >
                <IconButton>
                  <NotificationsIcon sx={{ color: "#2e2e2e" }} />
                </IconButton>

                <Box
                  sx={{
                    position: "absolute",
                    top: -4,
                    right: -4,
                    backgroundColor: "#0057ff",
                    color: "#fff",
                    borderRadius: "50%",
                    minWidth: 18,
                    height: 18,
                    fontSize: 11,
                    fontWeight: 600,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontFamily: "Poppins, sans-serif",
                    lineHeight: 1,
                  }}
                >
                  2
                </Box>
              </Box>

              <IconButton onClick={handleClick2}>
                <PersonIcon sx={{ color: "#2e2e2e" }} />
              </IconButton>

              {/* <IconButton onClick={handleClick2}>
                <Box
                  component='img'
                  src={profile} // Path to your image
                  alt='Notification'
                  sx={{
                    width: 24,
                    height: 24,
                    objectFit: "contain",
                  }}
                />
              </IconButton> */}
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
      <Drawer
        variant='permanent'
        open={open}
        sx={{
          width: drawer == "miniopen" ? drawerWidth : 60, // 👈 IMPORTANT
          transition: "width 0.3s",
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawer == "miniopen" ? drawerWidth : 60, // 👈 IMPORTANT
            transition: "width 0.3s",
            overflowX: "hidden",
            boxSizing: "border-box",
            border: "none",
          },
        }}
      >
        <DrawerHeader sx={{ gap: 1 }}>
          {drawer == "miniopen" && (
            <Box
              sx={{ mt: 1, cursor: "pointer" }}
              onClick={() => {
                navigate("/Home");
                sessionStorage.setItem("selectnav1", "Dashboard");
              }}
            >
              <Typography
                sx={{
                  fontWeight: 700,
                  color: "#144FEE",
                  fontFamily: "Poppins, sans-serif",
                  fontSize: "0.9rem",
                }}
              >
                Customer Portal
              </Typography>
              <Typography
                sx={{
                  color: "#144FEE",
                  fontFamily: "Poppins, sans-serif",
                  fontSize: "0.6rem",
                }}
              >
                Customer Support Assistant
              </Typography>
            </Box>
          )}

          <Grid
            sx={{ width: 40, height: 40 }}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
          >
            {/* {hover && ( */}
            <Grid>
              {/* {theme.direction === "ltr" ? (
                  <IconButton onClick={handleDrawerClose}>
                    {/* <ChevronLeftIcon /> */}
              {/* ""
                  </IconButton>
                ) : (
                  <ChevronRightIcon />
                )} */}

              {drawer == "miniopen" ? (
                <IconButton
                  onClick={() => {
                    sessionStorage.setItem("mini", "miniclose");
                    handleDrawerClose();
                  }}
                >
                  <ChevronLeftIcon />
                </IconButton>
              ) : (
                <IconButton
                  onClick={() => {
                    sessionStorage.setItem("mini", "miniopen");
                    handleDrawerOpen();
                  }}
                >
                  <ChevronRightIcon />
                </IconButton>
              )}
            </Grid>
            {/* )} */}
          </Grid>
        </DrawerHeader>
        <List>
          {menuItems.map((item, index) => (
            <ListItem
              key={item.text}
              disablePadding
              onClick={() => {
                sessionStorage.setItem("selectnav1", item.text);
                navigate(`/${item.path}`);
                setHeading(item.text);
              }}
            >
              <ListItemButton
                sx={{
                  backgroundColor:
                    sessionStorage.getItem("selectnav1") == item.text
                      ? "#144FEE"
                      : "",
                  "&:hover": {
                    backgroundColor:
                      sessionStorage.getItem("selectnav1") == item.text
                        ? "#144FEE"
                        : "rgba(20, 79, 238, 0.08)",
                  },
                  borderRadius: "0px",
                  // mx: 1,
                  // mt: 0.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 40,
                  }}
                >
                  <item.icon
                    sx={{
                      fontSize: 24,
                      color:
                        sessionStorage.getItem("selectnav1") == item.text
                          ? "#fff"
                          : "",
                    }}
                  />
                </ListItemIcon>

                {drawer == "miniopen" && (
                  <ListItemText
                    primary={
                      <Typography
                        sx={{
                          color:
                            sessionStorage.getItem("selectnav1") == item.text
                              ? "#fff"
                              : "#000",
                          fontWeight:
                            sessionStorage.getItem("selectnav1") == item.text
                              ? 600
                              : "",
                          fontFamily: "Poppins, sans-serif",
                          fontSize: "13px",
                        }}
                      >
                        {item.text}
                      </Typography>
                    }
                  />
                )}
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Drawer>
      <Main open={open} sx={{ pl: 0, bgcolor: "#fafafa" }}>
        <DrawerHeader />
        {children}
      </Main>

      <div>
        <Popover
          id={id}
          open={bellOpen}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          slotProps={{
            paper: {
              sx: {
                borderRadius: 5, // rounded corners
                mt: 1, // small margin from icon
              },
            },
          }}
        >
          <Card
            sx={{
              width: 420,
              borderRadius: 5,
              boxShadow: "0px 4px 20px rgba(0,0,0,0.08)",
              overflow: "hidden",
            }}
          >
            {/* Header */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                p: 2,
                bgcolor: "#f7faff",
                paddingLeft: 2,
                paddingRight: 2,
              }}
            >
              <Typography
                sx={{
                  fontSize: "1rem",
                  fontWeight: 600,
                  fontFamily: "Poppins, sans-serif",
                }}
              >
                Notifications
              </Typography>

              <Typography
                sx={{
                  fontSize: "0.7rem",
                  color: "#144FEE",
                  cursor: "pointer",
                  fontWeight: 500,
                  "&:hover": { textDecoration: "underline" },
                  fontFamily: "Poppins, sans-serif",
                }}
              >
                Mark all as read
              </Typography>
            </Box>

            {/* Notification list */}

            <TableContainer>
              <Table>
                <TableBody>
                  {notifications.map((item, index) => (
                    <TableRow
                      key={index}
                      hover
                      sx={{
                        cursor: "pointer",
                        "&:hover": { backgroundColor: "#f5f7ff" },
                      }}
                    >
                      {/* LEFT SIDE — Title + Description */}
                      <TableCell
                        sx={{ width: "70%", borderBottom: "1px solid #eee" }}
                      >
                        <Typography
                          sx={{
                            fontFamily: "Poppins, sans-serif",
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                            lineHeight: 1.3,
                          }}
                        >
                          <span
                            style={{ fontWeight: 600, fontSize: "0.75rem" }}
                          >
                            {item.title}
                          </span>
                          <span
                            style={{
                              fontWeight: 400,
                              fontSize: "0.65rem",
                              color: "#666",
                              marginLeft: 4,
                            }}
                          >
                            {item.desc}
                          </span>
                        </Typography>
                      </TableCell>

                      {/* RIGHT SIDE — Time */}
                      <TableCell
                        align='right'
                        sx={{
                          width: "30%",
                          fontFamily: "Poppins, sans-serif",
                          fontSize: "0.7rem",
                          color: "#999",
                          borderBottom: "1px solid #eee",
                        }}
                      >
                        {item.time}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            {/* Footer */}
            <Box sx={{ p: 2, textAlign: "center" }}>
              <Typography
                sx={{
                  fontSize: 15,
                  cursor: "pointer",
                  color: "#144FEE",
                  fontFamily: "Poppins, sans-serif",
                  //textDecoration: "underline", // same as link hover
                  "&:hover": {
                    textDecoration: "underline", // hover effect
                  },
                }}
              >
                View all notifications
              </Typography>
            </Box>
          </Card>
        </Popover>
      </div>

      <div>
        <Popover
          id={id2}
          open={profileOpen}
          anchorEl={anchorEl2}
          onClose={handleClose2}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          slotProps={{
            paper: {
              sx: {
                borderRadius: 5, // rounded corners
                mt: 1, // small margin from icon
              },
            },
          }}
        >
          <Card
            sx={{
              width: 420,
              borderRadius: 5,
              boxShadow: "0px 4px 20px rgba(0,0,0,0.08)",
              overflow: "hidden",
              padding: 2,
            }}
          >
            {/* Email */}
            <Typography
              sx={{
                fontSize: 15,
                fontWeight: 500,
                mb: 1,
                textAlign: "center",
                fontFamily: "Poppins, sans-serif",
              }}
            >
              {sessionStorage.getItem("custemail")}
            </Typography>

            {/* Avatar + Greeting */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                mt: 1,
                mb: 2,
              }}
            >
              <Avatar sx={{ width: 56, height: 56, bgcolor: "purple" }}>
                {sessionStorage.getItem("custname")?.[0]?.toUpperCase()}
              </Avatar>

              <Typography
                sx={{
                  fontSize: 18,
                  fontWeight: 600,
                  mt: 1,
                  fontFamily: "Poppins, sans-serif",
                }}
              >
                Hi, {sessionStorage.getItem("cust_name")} !
              </Typography>

              {/* <Button
                variant='outlined'
                sx={{
                  textTransform: "none",
                  mt: 1.5,
                  borderRadius: 20,
                  fontSize: 14,
                  color: "#144FEE",
                  fontFamily: "Poppins, sans-serif",
                  border: "1px solid #144FEE",
                }}
                onClick={() => {
                  navigate("/MyProfile");
                  sessionStorage.setItem("selectnav1", "My Profile");
                }}
              >
                Manage your Account
              </Button> */}
            </Box>

            <Divider sx={{ my: 2 }} />

            {/* Buttons */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <Button
                variant='contained'
                sx={{
                  textTransform: "none",
                  borderRadius: 2,
                  bgcolor: "#144FEE",
                  color: "white",
                  boxShadow: "none",
                  "&:hover": { bgcolor: "#144FEE", boxShadow: "none" },
                }}
                onClick={() => {
                  navigate("/");
                  sessionStorage.clear();
                }}
              >
                ↪ Sign out
              </Button>
            </Box>

            <Box sx={{ textAlign: "center", mt: 2 }}>
              <Typography
                sx={{
                  fontSize: 12,
                  color: "gray",
                  fontFamily: "Poppins, sans-serif",
                }}
              >
                Privacy Policy · Terms of Service
              </Typography>
            </Box>
          </Card>
        </Popover>
      </div>
    </Box>
  );
}
